/**
 * 购买守护真爱榜单列表
 * data-threshold优先级高于实例化时候传入的统一配置参数。
 */
define(function(require, exports, module) {
    var RankList = require('../base/ranklist');
    var itemTpl = require('./item.tmpl');
    var emptyTpl = require('./empty-item.tmpl');
    
    const HostList = RankList.extend({
        defaults: {
            wrap: '#J-HostList',
            itemTpl: itemTpl,
            itemEmptyTpl: emptyTpl
        },

        initialize() {
            let self = this;
            this.set('itemEmptyTpl',emptyTpl)
            self.Parent.apply(self, arguments);

            self.set('url', UpAct.CONFIG.getTrueLoveList());
        }
    });

    UpAct.TrueLoveList = HostList;
});



// WEBPACK FOOTER //
// ./js/component/truelovelist/index.js